import { addTime, daysBetween } from './dates';

export const BOOKING_PRICING_HELP_URL =
  'https://www.setcirclehelp.com/en/articles/16302762-how-booking-dates-pricing-work';
export const BUYING_SELLING_HELP_URL =
  'https://www.setcirclehelp.com/en/articles/12787174-buying-selling-guide';

// Pickup + drop-off (free) with at least one paid rental day between them.
export const MIN_PICKUP_DROPOFF_NIGHTS = 2;

/**
 * Map picker dates (pickup → exclusive end after drop-off) to Sharetribe booking params.
 * Reserved range is only the paid rental days; display range stays pickup/drop-off.
 *
 * @param {Date} displayStart pickup date
 * @param {Date} displayEnd exclusive end (day after drop-off)
 * @param {String} [timeZone]
 * @returns {{bookingStart: Date, bookingEnd: Date, bookingDisplayStart: Date, bookingDisplayEnd: Date}|null}
 */
export const toRentalAvailabilityParams = (displayStart, displayEnd, timeZone) => {
  if (!(displayStart instanceof Date) || !(displayEnd instanceof Date)) {
    return null;
  }

  const bookingStart = addTime(displayStart, 1, 'days', timeZone);
  const bookingEnd = addTime(displayEnd, -1, 'days', timeZone);

  if (!(bookingStart instanceof Date) || !(bookingEnd instanceof Date)) {
    return null;
  }
  if (bookingEnd.getTime() <= bookingStart.getTime()) {
    return null;
  }

  return {
    bookingStart,
    bookingEnd,
    bookingDisplayStart: displayStart,
    bookingDisplayEnd: displayEnd,
  };
};

export const chargedDaysFromBookingRange = (bookingStart, bookingEnd) => {
  if (!(bookingStart instanceof Date) || !(bookingEnd instanceof Date)) {
    return null;
  }
  try {
    const days = daysBetween(bookingStart, bookingEnd);
    return days > 0 ? days : null;
  } catch (e) {
    return null;
  }
};
